/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IngestionStatusControllerGetFileWebAppLinkQueryResponse, IngestionStatusControllerGetFileWebAppLinkPathParams, IngestionStatusControllerGetFileWebAppLink403, IngestionStatusControllerGetFileWebAppLink404 } from "../../models/documentIngestionStatusController/IngestionStatusControllerGetFileWebAppLink";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { ingestionStatusControllerGetFileWebAppLink } from "../../clients/document-ingestion-statusService/ingestionStatusControllerGetFileWebAppLink";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const ingestionStatusControllerGetFileWebAppLinkQueryKey = (fileId: IngestionStatusControllerGetFileWebAppLinkPathParams["fileId"]) => [{
  url: '/api/v1/documents/ingestion-status/files/:fileId/web-app-link',
  params: {
    fileId: fileId
  }
}] as const;
export type IngestionStatusControllerGetFileWebAppLinkQueryKey = ReturnType<typeof ingestionStatusControllerGetFileWebAppLinkQueryKey>;
export function ingestionStatusControllerGetFileWebAppLinkQueryOptions(fileId: IngestionStatusControllerGetFileWebAppLinkPathParams["fileId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = ingestionStatusControllerGetFileWebAppLinkQueryKey(fileId);
  return queryOptions<IngestionStatusControllerGetFileWebAppLinkQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetFileWebAppLink403 | IngestionStatusControllerGetFileWebAppLink404>, IngestionStatusControllerGetFileWebAppLinkQueryResponse, typeof queryKey>({
    enabled: !!fileId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return ingestionStatusControllerGetFileWebAppLink(fileId, config);
    }
  });
}

/**
 * @description Returns the canonical fully-qualified URL for opening this file in the main web app. The host is sourced from FRONTEND_URL (set per environment by Pulumi). Requires System Administrator role.
 * @summary Resolve the main web app URL for a file
 * {@link /api/v1/documents/ingestion-status/files/:fileId/web-app-link}
 */
export function useIngestionStatusControllerGetFileWebAppLink<TData = IngestionStatusControllerGetFileWebAppLinkQueryResponse, TQueryData = IngestionStatusControllerGetFileWebAppLinkQueryResponse, TQueryKey extends QueryKey = IngestionStatusControllerGetFileWebAppLinkQueryKey>(fileId: IngestionStatusControllerGetFileWebAppLinkPathParams["fileId"], options: {
  query?: Partial<QueryObserverOptions<IngestionStatusControllerGetFileWebAppLinkQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetFileWebAppLink403 | IngestionStatusControllerGetFileWebAppLink404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? ingestionStatusControllerGetFileWebAppLinkQueryKey(fileId);
  const query = useQuery({
    ...ingestionStatusControllerGetFileWebAppLinkQueryOptions(fileId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<IngestionStatusControllerGetFileWebAppLink403 | IngestionStatusControllerGetFileWebAppLink404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}